import axios from "axios";
import { computed, runInAction, decorate, observable } from "mobx";
import BaseUrl from "../../../Stores/DataStore/Enums/BaseUrl";

export default class ModelStore {
  constructor(modelType, url, store = null) {
    this.store = store ? store : this;
    this._modelType = modelType;
    const baseUrl = new BaseUrl();
    this._url = baseUrl.SERVERURL + url;
    this._idKey = "Id";

    this._data = [];
    this.fetching = false;
    this.fetched = false;
    this.lastError = null;
  }

  get length() {
    return this._data.length;
  }

  fetch(queryParams = "", postData) {
    const url = `${this._url}${queryParams}`;
    console.log(url);
    let promise = null;
    if (this.fetching) {
      console.log(`already fetching: ${url}`);
    } else {
      console.log(`fetching: ${url}`);
      this.fetching = true;      
      axios.defaults.headers.common["Authorization"] = localStorage["its_my_token"];
      if (postData) promise = axios.post(url, postData);
      else promise = axios.get(url);
      promise
        .then(
          function(response) {
            console.log(`received: ${url}`);
            if (response.data instanceof Array) {
              this.updateFromJson(response.data);
            } else if (response.data instanceof Object) {
              this.updateModelFromJson(response.data);
            }
            this.fetching = false;
            console.log(`processed: ${url}`);
          }.bind(this)
        )
        .catch(
          function(error) {
            debugger;
            console.log(`failed fetching: ${url}`, error);
            runInAction(() => {
              this.fetching = false;
              this.lastError = error;
            });
          }.bind(this)
        );
    }
    return promise;
  }

  fetchId(id) {
    return this.fetch(`/${id}`);
  }

  storeModel(model, successCallback, failureCallback) {
    const url = this._url;
    const json = model.asJSON || {};
    const method = model.isNew ? "post" : "put";

    console.log(url);
    console.log(`store: ${method}: ${url}`);
    const promise = axios
      .request({
        method: method,
        url: url,
        data: json,
        headers: {
          "content-type": "application/json"
        }
      })
      .then(
        function(response) {
          console.log(`received: ${url}`);

          // if Id are numeric (autoincrement) update the id separate, we should
          // use Guid for all Id's in the future
          if (typeof response.data[this._idKey] === "number") {
            model[this._idKey] = response.data[this._idKey];
          }

          this.updateModelFromJson(response.data);
          console.log(`processed: ${url}`);
          if (successCallback) successCallback(json[this._idKey]);
        }.bind(this)
      )
      .catch(
        function(error) {
          console.log(`failed storing: ${url}`, error);
          runInAction(() => {
            this.lastError = error;
          });
          if (failureCallback) failureCallback(json[this._idKey], error);
        }.bind(this)
      );

    return promise;
  }

  deleteById(id, successCallBack, failureCallback) {
    const url = `${this._url}/${id}`;
    let model = this.findById(id);
    console.log(`delete: ${url}`);
    return axios
      .delete(url)
      .then(
        function(response) {
          console.log(`received: ${url}`);
          if (successCallBack) successCallBack(id);
          if (model) {
            this.remove(model);
          }
          console.log(`processed: ${url}`);
        }.bind(this)
      )
      .catch(
        function(error) {
          console.log(`failed deleting: ${url}`, error);
          this.lastError = error;
          console.dir(error);
          if (failureCallback) failureCallback(id, error);
        }.bind(this)
      );
  }

  clear() {
    this._data.clear();
  }

  findById(id) {
    let model = null;
    if (id !== null && id !== undefined) {
      model = this._data.find(model => model.Id === id);
    }
    return model;
  }

  add(id) {
    const model = new this._modelType(this, id);
    this._data.push(model);
    return model;
  }

  beforeUpdateFromJson() {}

  updateModelFromJson(json) {
    const id = json[this._idKey];
    let model = this.findById(id);
    if (!model) {
      model = this.add(id);
    }
    try {
      model.updateFromJson(json, this._idKey);
    } catch (ex) {
      console.error(ex);
      throw ex;
    }
  }

  updateFromJson(data) {
    runInAction(() => {
      this.beforeUpdateFromJson();
      Object.keys(data).forEach(
        function(key) {
          const json = data[key];
          this.updateModelFromJson(json);
        }.bind(this)
      );
      this.fetched = true;
      this.fetching = false;
      this.lastError = null;
    });
  }

  remove(model) {
    if (model) {
      this._data.remove(model);
    }
  }

  find(func, thisValue) {
    return this._data.find(func, thisValue);
  }

  filter(func, thisValue) {
    return this._data.filter(func, thisValue);
  }

  forEach(func) {
    return this._data.map(func);
  }

  map(func) {
    return this._data.map(func);
  }

  fetchAfterErrorHandler(id, error) {
    if (id) {
      const model = this.findById(id);
      if (model) {
        if (model.isNew) this.remove(model);
        else this.fetchId(id);
      }
    } else {
      this.fetch();
    }
  }
}

decorate(ModelStore, {
  _data: observable,
  fetching: observable,
  fetched: observable,
  lastError: observable,
  length: computed
});



// WEBPACK FOOTER //
// ./src/Core/Stores/ModelStore/index.js